import { createKemsuWebSystemPageUrl } from "./createKemsuWebSystemPageUrl"
import { kemsuWebServer } from "~/shared/config"

/**
 * Используется для обновления параметров сессии в системе на KemsuWeb.
 * Создает скрытый iframe с указанным адресом страницы системы на KemsuWeb и после загрузки удаляет его.
 * @param path путь
 * @param searchParams объект, который содержит search-параметры
 * @param https использовать https
 * @param server имя сервера
 * @example
 * import {execKemsuWebSystemPage} from "~/shared/api/kemsuweb";
 *
 * execKemsuWebSystemPage('test/path.htm', { param: "value" }, true)
 *         .then(() => console.log('Успех!'))
 *         .catch(err => console.error(err));
 */
export function execKemsuWebSystemPage(
	path: string,
	searchParams: { [k: string]: string | number } = {},
	https = true,
	server = kemsuWebServer,
): Promise<void | ErrorEvent> {
	return new Promise((resolve, reject) => {
		const iframe = document.createElement("iframe")

		iframe.name = Date.now().toString() // для предотвращения кэширования
		iframe.src = createKemsuWebSystemPageUrl(
			path,
			searchParams,
			https,
			server,
		)
		iframe.style.display = "none"

		iframe.addEventListener("load", () => {
			resolve()
			iframe.parentNode?.removeChild(iframe)
		})

		iframe.addEventListener("error", (err) => {
			reject(err)
			iframe.parentNode?.removeChild(iframe)
		})

		document.body.appendChild(iframe)
	})
}
